import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="max-w-xl mx-auto my-16 rounded-lg border border-rose-200 bg-rose-50 p-6 text-rose-800" role="alert" data-testid="error-boundary">
        <div className="flex items-center gap-2 font-semibold"><AlertTriangle className="w-5 h-5" /> Κάτι πήγε στραβά σε αυτή τη σελίδα</div>
        <p className="mt-2 text-sm">Τα δεδομένα σας είναι ασφαλή. Ανανεώστε τη σελίδα· αν επαναληφθεί, στείλτε μας το παρακάτω μήνυμα.</p>
        <pre className="mt-3 text-xs whitespace-pre-wrap bg-white/70 rounded p-2 text-rose-700" data-testid="error-boundary-message">{String(this.state.error?.message || this.state.error)}</pre>
        <button type="button" onClick={() => window.location.reload()} className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-rose-600 px-3 py-2 text-sm font-semibold text-white hover:bg-rose-700" data-testid="error-boundary-reload-btn">
          <RotateCcw className="w-4 h-4" /> Ανανέωση σελίδας
        </button>
      </div>
    );
  }
}
